import axios from "axios";
import React, { useEffect, useState } from "react"
import Doctor from "../images/doctorAvtar.png";
import DoctorSlotAvailability from "./DoctorSlotAvailability";
import { decryptData } from "../Services/TabServices";
const SlotsDoctorAvailability=()=>{
const [doctors,setDoctors]=useState([]);
const [openPopUp,setOpenPopUp]=useState(false)
const [selectedDoctorId,setSelectedDoctorId]=useState("")
  const [isLoading,setLoading]=useState(false);
  const [hoveredDoctor, setHoveredDoctor] = useState(null); 

  const storedUserId = sessionStorage.getItem("userId");
const CrmID = storedUserId ? decryptData(storedUserId) : null;
  const token = sessionStorage.getItem("token");
  useEffect(()=>{
const GetAllDoctorsService =async()=>{
    try {
      setLoading(true)
       const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorsByCrmId`, 
       {
            params: {crmId: CrmID },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
  );
  
      setDoctors(response.data)

    } catch (error: any) {
        throw new Error(`GetAllDoctorsService error: ${error?.message}`);
    }finally{
    setLoading(false)
    }
}
GetAllDoctorsService();
},[]
)

const handleSlotAvailability=(doctorId:string)=>{
setSelectedDoctorId(doctorId)
setOpenPopUp(true)
}
const handleClosePopup=()=>{
setOpenPopUp(false)
}
    return(
 <div className="ml-2">
  <div className="w-full">
        <div className="sticky top-[128px] sm:top-[140px]   w-full bg-[#F5F5F5] pb-3 z-10">
        <div className="flex justify-between">
          <div>
            <p className="text-[16px] font-semibold w-full">Doctors Listing</p>
            <p className="text-[12px] text-[#606060] w-full">Our Top Doctors</p>
          </div>
</div>
</div>

<div className="w-[95%] rounded-md mt-3 flex-1 overflow-y-auto"
        style={{ height: "calc(100vh - 190px)" }}>
<div className="mt-7">
 {isLoading ? (
   <div className="relative w-ful mt-6 h-[200px] flex justify-center items-center py-10">
   <div className="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
 </div>
) : doctors?.length === 0 ? (
  <div className="w-full flex flex-col items-center justify-center text-center text-gray-600 font-semibold text-lg pt-10">
    <img src={Doctor} alt="No Doctor" className="w-32 h-32" />
    <div className="w-full flex flex-col items-center justify-center text-center text-gray-600 font-semibold text-lg py-4">
      <p className="text-xl font-bold text-[#184A84]">No Doctors Available</p>
      <p className="text-sm text-gray-500 mt-2">
        Currently, there are no doctors available for this speciality.<br/>
        <span className="text-[#009A85] font-semibold">Doctors will be available soon!</span>
       </p>
    </div>
  </div>
) : (
  <div className=" gap-4 mt-16">
    {doctors.map((doctor: any, index: number) => (
    <div
  key={doctor.doctorId}
  className="grid grid-cols-1  md:grid-cols-5 items-center bg-white px-3 sm:px-4 py-3 rounded-xl shadow-sm hover:shadow-md border border-gray-100 transition-all gap-3 sm:gap-4"
>
  {/* Doctor Avatar */}
  <div className="flex items-center sm:justify-center gap-3">
    <img
      src={
        doctor.doctorImage
          ?`${process.env.REACT_APP_BASE_URL}/${doctor.doctorImage}`
          :Doctor
      }
      alt={doctor.doctorName}
      className="w-14 h-16 rounded-full border "
    />
    {/* Show name + fees right next to image on mobile */}
    <div className="flex flex-col sm:hidden">
      <p className="text-sm font-semibold text-gray-900 truncate">
        {doctor.doctorName}
      </p>
      <p className="text-xs text-gray-500">₹{doctor.doctorFees}</p>
    </div>
  </div>

  {/* Name & Fees (hidden on mobile, visible on sm+) */}
  <div className="hidden sm:flex flex-col">
    <p className="text-sm sm:text-base font-semibold text-gray-900 truncate">
      {doctor.doctorName}
    </p>
    <p className="text-xs sm:text-sm text-gray-500">₹{doctor.doctorFees}</p>
  </div>

  {/* Gender & Location (only sm+) */}
  <div className="hidden sm:flex flex-col">
    <p className="text-xs sm:text-sm text-gray-700">
      {doctor.gender === "M" ? "Male" : "Female"}
    </p>
    <p className="text-xs sm:text-sm text-gray-500 truncate">
      {doctor.location}
    </p>
  </div>

  {/* Specialization & Qualification */}
 <div 
            className="flex flex-col relative"
            onMouseEnter={() => setHoveredDoctor(doctor.doctorId)}
            onMouseLeave={() => setHoveredDoctor(null)}
          >    <p className="text-xs sm:text-sm font-medium text-gray-800 truncate">
      {doctor.specializationName}
    </p>
    <p className="text-xs sm:text-sm text-gray-500 truncate">
      {doctor.qualification}
    </p>
    {hoveredDoctor === doctor.doctorId && doctor.qualification && (
          <div className="absolute top-full left-0 mb-2 z-50 bg-gray-800 text-white text-xs rounded-md py-2 px-3 shadow-lg max-w-xs w-max">
  <div className="font-semibold mb-1">Qualification:</div>
  <div>{doctor.qualification}</div>

  {/* Upward arrow */}
  <div className="absolute bottom-full left-4 w-0 h-0 
                  border-l-4 border-l-transparent 
                  border-r-4 border-r-transparent 
                  border-b-4 border-b-gray-800"></div>
</div> )}
  </div>

  {/* Actions */}
  <div className="flex items-center justify-end sm:justify-start gap-2 sm:gap-3">
    <button
      className="bg-[#009A85] text-white text-xs sm:text-sm font-medium px-3 sm:px-5 py-1.5 rounded-md hover:bg-[#038775] transition-colors"
      onClick={() => handleSlotAvailability(doctor.doctorId)}
    >
      View Slots
    </button>

    {openPopUp && (
      <DoctorSlotAvailability
        doctor={selectedDoctorId}
        onClose={handleClosePopup}
      />
    )}
  </div>
</div>

    ))}
  </div>
)}
</div>
</div>
</div>
</div>
    );
}
export default SlotsDoctorAvailability;